import { render } from "./ManageDevices.vue?vue&type=template&id=5998bd4e&ts=true"
import script from "./ManageDevices.vue?vue&type=script&lang=ts"
export * from "./ManageDevices.vue?vue&type=script&lang=ts"

import "./ManageDevices.vue?vue&type=style&index=0&id=5998bd4e&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__